import validation from '../../../services/validation';
import template from './gas.jade';
import gasTypes from '../../../enums/gas-type';

export default angular.module('cian.addForm.commonGas', []).directive('cianAfCommonGas', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller() {
    'ngInject';

    this.items = gasTypes;

    this.validation = validation(this.form, 'gas.type', {
      required: 'Обязательное поле',
    });

    const isUnknownType = typeof this.ad.hasGas === 'undefined' || this.ad.hasGas;

    if (isUnknownType && this.ad.gas?.type) {
      this.value = this.ad.gas.type;
    } else if (this.ad.hasGas === false && !this.ad.gas?.type) {
      this.value = 'no';
    }

    const updateGasValue = ({ gasType, hasGas }) => {
      const gas = gasType ? { ...this.ad.gas, type: gasType } : undefined;

      this.ad = {
        ...this.ad,
        gas,
        hasGas,
      };
    };

    this.handleChange = () => {
      const gasValue =
        this.value === 'no' ? { hasGas: false } : { gasType: this.value, hasGas: this.ad.hasGas || undefined };

      updateGasValue(gasValue);
    };
  },
  controllerAs: 'gas',
  template,
})).name;
